import React from "react";
import jsPDF from "jspdf";
import imgData from '../../../Assest/kk.png'

const DownloadDivWork = ({ mat, file, ch, ansDownload, Reminder }) => {
    const generatePDF = () => {
        const today = new Date();
        const dateString = today.toLocaleDateString("en-GB").split("/").reverse().join("-");
        const fileName = ansDownload
            ? `${file} - With Answer - ${dateString}.pdf`
            : `${file} - Question - ${dateString}.pdf`;

        let operationSymbol

        if(ch == 'd'){
            operationSymbol = " ÷ " ;
        }else if(ch == 'm'){
            operationSymbol = " x "
        }
        const doc = new jsPDF("p", "pt");

        // Table settings
        const tableWidth = 180; // Width of each table
        const rowHeight = 30; // Height of each row
        const columnWidths = [30, 120]; // Column widths for number and question text
        const questionsPerTable = 25; // Number of questions per table
        const tableSpacing = 20; // Spacing between tables
        const marginX = 40; // Left margin
        const marginY = 75; // Top margin
        const tableGapX = 0; // Space between tables horizontally
        doc.text(marginX, 50, "WorkSheet : ")
        doc.text(380, 50, "Date :  ___/___/____")
        doc.setFontSize(12);
        // Add header image
        doc.addImage(imgData, 'PNG', 20, 20, 500, 500);


        let currentTable = 0; // Track current table number (0, 1, 2 for each page)
        let currentQuestion = 0; // Track current question number

        for (let i = 0; i < mat.length; i++) {

            // Check if we need to move to the next table
            if (currentQuestion > 0 && currentQuestion % questionsPerTable === 0) {
                currentTable++;
            }
            if (currentTable === 3 && currentQuestion % questionsPerTable === 0 && currentQuestion > 0) {
                doc.addPage();
                // doc.addImage(imgData, "PNG", 20, 20, 500, 60);
                doc.addImage(imgData, 'PNG', 20, 20, 500, 500);
                currentTable = 0; // Reset to the first table for the new page
                currentQuestion = 0; // Reset question counter for new page
            }

            const tableX = marginX + currentTable * (tableWidth + tableGapX);
            const tableY = marginY + (currentQuestion % questionsPerTable) * rowHeight;
            // Draw the row
            doc.setDrawColor(0, 0, 0); // Black borders
            doc.rect(tableX, tableY, tableWidth, rowHeight); // Draw row rectangle

            // Draw vertical dividers
            // doc.line(
            //     tableX + columnWidths[0],
            //     tableY,
            //     tableX + columnWidths[0],
            //     tableY + rowHeight
            // );

            // Fill background color for the serial number column
            // doc.setFillColor(200, 162, 200); // Light purple
        doc.setFillColor(204, 192, 212);
            doc.rect(tableX, tableY, columnWidths[0], rowHeight, "F"); // Draw filled rectangle
            doc.rect(tableX, tableY, columnWidths[0], rowHeight); // Draw filled rectangle

            // Fill row content

            doc.setDrawColor(0, 0, 0); // Reset to black for text
            doc.text(`${i + 1}`, tableX +5, tableY + 20); // Question number
            console.log(ch)

            if(!ansDownload){
                doc.text(
                    `${mat[i][0]}${operationSymbol}${mat[i][1]} =`,
                    tableX + columnWidths[0] + 5,
                    tableY + 20
                ); // Question text    
            }else{
                if(ch == 'd' && !Reminder){
                    doc.text(
                        `${mat[i][0]}${operationSymbol}${mat[i][1]} = ${mat[i][0] / mat[i][1]}`,
                        tableX + columnWidths[0]+2,
                        tableY + 20
                    ); // Question text
                }else if(ch == 'd' && Reminder==1){
                    doc.text(
                        `${mat[i][0]}${operationSymbol}${mat[i][1]}  =  ${mat[i][0] % mat[i][1]}`,
                        tableX + columnWidths[0]+2,
                        tableY + 20
                    ); // Question text
                }
                if(ch == 'm'){
                    doc.text(
                        `${mat[i][0]}${operationSymbol}${mat[i][1]} = ${mat[i][0] * mat[i][1]}`,
                        tableX + columnWidths[0]+2,
                        tableY + 20
                    ); // Question text
                }
            }




            // Add answer if required
            // if (ansDownload) {
            //     const answer = Reminder
            //         ? mat[i][0] % mat[i][1]
            //         : ch === "d"
            //             ? (mat[i][0] / mat[i][1]).toFixed(2)
            //             : mat[i][0] * mat[i][1];
            //     doc.text(`${answer}`, tableX + tableWidth - 50, tableY + 20); // Answer text
            // }                                                                               

            currentQuestion++;
        }

        doc.save(fileName);
    };

    return (
        <div>
            <button className="bt-purple" onClick={generatePDF} type="primary">
                {ansDownload ? "Download Question + Answer Pdf" : "Download Question Pdf"}
            </button>
        </div>
    );
};

export default DownloadDivWork;
